import React, {useEffect, Fragment} from 'react';
import {CircularProgress, Stack} from '@mui/material';

import probeConnection, {SCIConnection, DEVICE_URL} from '../../imports/ec9xns/ec9xns-connection.js';

import {CONNECTION_STATE} from './StateConstants.jsx';
import PropTypes from 'prop-types';

function getElementValue(parentElem, tagName) {
  const elemt = parentElem.getElementsByTagName(tagName);
  if (elemt!== undefined && elemt.length > 0 ) {
    return elemt[0].childNodes[0].nodeValue;
  } else {
    console.log(tagName + ' elem is empty');
    return null;
  }
}

function isEmptyString(str) {
  return !str || str === '';
}

const ConnectingStep = (props) => {
  ConnectingStep.propTypes = {
    reconnecting: PropTypes.bool.isRequired,
    setState: PropTypes.func.isRequired,
    setScannerInfo: PropTypes.func.isRequired,
    setDeviceURL: PropTypes.func.isRequired
  };

  const doConnectScanner = () => {
    const doGetScannerXml = async (sciConnection) => {
      const id = 'self-service';
      try {
        await sciConnection.claimScanner(id);
        await new Promise((r) => setTimeout(r, 500));
        const [xmlDoc] = await sciConnection.getScannerXml(id);

        if (props.reconnecting) {
          props.setState(CONNECTION_STATE.UPDATE_DONE_REFRESH);
          return;
        }

        let scannerData = {model: null, sn: null, version: null};
        const sn = getElementValue(xmlDoc, 'MetaSerialNumber');
        if (isEmptyString(sn)) {
          console.log('sn is empty');
          props.setState(CONNECTION_STATE.NOT_CONNECTED);
          return;
        }
        scannerData.sn = sn;

        const model = getElementValue(xmlDoc, 'MetaScannerType');
        if (isEmptyString(model)) {
          console.log('model is empty');
          props.setState(CONNECTION_STATE.NOT_CONNECTED);
          return;
        }
        scannerData.model = model;

        let librcp_version = null;
        let firmware_version = null;
        const versionDataElemts = xmlDoc.getElementsByTagName('VersionData');
        if (versionDataElemts == undefined || versionDataElemts.length == 0 ) {
          console.log('<VersionData> is empty, search <VersionRcp>');
          librcp_version = getElementValue(xmlDoc, 'VersionRcp');
        } else {
          for (let i = 0; i < versionDataElemts.length; i++) {
            const name = getElementValue(versionDataElemts[i], 'Name');
            if (!isEmptyString(name)) {
              if (name === 'Firmware') {
                firmware_version = getElementValue(versionDataElemts[i], 'Version');
              } else if (name === 'librcp') {
                librcp_version = getElementValue(versionDataElemts[i], 'Version');
              }
            }
          }
        }

        if (!isEmptyString(firmware_version)) {
          scannerData.version = firmware_version;
        } else if (!isEmptyString(librcp_version)) {
          scannerData.version = librcp_version;
        } else {
          console.log('version is empty');
          props.setState(CONNECTION_STATE.UPDATE_DONE);
          return;
        }

        console.log(`{model: "${scannerData.model}", sn: "${scannerData.sn}", version: "${scannerData.version}"}`);
        props.setScannerInfo(scannerData);
        props.setState(CONNECTION_STATE.CONNECTED);
      } catch (err) {
        // Ignorar errores de red durante el refresh post-update
        const isNet = err?.code === 'ERR_NETWORK' || /Network Error/i.test(err?.message || '');
        if (props.reconnecting && isNet) {
          console.warn('[ConnectingStep] post-update refresh ignored:', err?.message || err);
          props.setState(CONNECTION_STATE.UPDATE_DONE_REFRESH);
          return;
        }
        console.log('doConnectScanner err = ' + err);
        props.setState(CONNECTION_STATE.NOT_CONNECTED);
      } finally {
        // Cleanup no-bloqueante: nunca debe romper la UI
        sciConnection.releaseScanner(id).catch(() => {});
        console.log('doConnectScanner done');
      }
    };

    // Unificado: siempre probamos por el mismo mecanismo (proxy en dev, IP en prod)
    probeConnection(null).then((scannerUrl) => {
      console.log(`scannerUrl: ${scannerUrl}`);
      props.setDeviceURL(scannerUrl);
      doGetScannerXml(new SCIConnection(scannerUrl));
    }, (err) => {
      console.log('message: ' + err.message);
      if (err.message && err.message.includes('(Network Error)')) {
        props.setDeviceURL(DEVICE_URL.HTTP_IP_8080);
        props.setState(CONNECTION_STATE.REDIRECT_TO_DASHBOARD);
      } else {
        props.setState(CONNECTION_STATE.NOT_CONNECTED);
      }
    });
  };

  useEffect(doConnectScanner, []);

  return (
    <Fragment>
      <div>Connecting to your Network Scanner. Please wait</div>
      <Stack alignItems="center"><CircularProgress/></Stack>
    </Fragment>
  );
};

export default ConnectingStep;
